import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useApp } from "../context/AppContext";

const Footer = () => {
  const { t } = useApp();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const subscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("WELCOME10");
    setEmail("");
  };

  const fl = t.footer.links;

  return (
    <footer className="bg-[var(--noir)] text-[var(--ivory)] grain mt-24" data-testid="footer">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10 lg:gap-16">
          <div className="md:col-span-2">
            <div className="font-display text-3xl tracking-[0.2em] mb-1">LUXERA</div>
            <div className="text-[10px] tracking-[0.4em] text-[var(--gold)] mb-6">KaLiMa</div>
            <p className="text-sm leading-relaxed text-[var(--grey-soft)] max-w-sm mb-8">{t.footer.tagline}</p>

            <div className="text-[11px] tracking-[0.2em] uppercase text-[var(--gold)] mb-3">{t.footer.newsletter}</div>
            <form onSubmit={subscribe} className="flex border-b border-[var(--grey)]" data-testid="footer-newsletter">
              <input
                type="email"
                required
                placeholder={t.sections.newsletterPh}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 bg-transparent py-3 text-sm outline-none placeholder:text-[var(--grey)]"
                data-testid="footer-newsletter-email"
              />
              <button className="px-4 text-xs tracking-[0.2em] uppercase hover:text-[var(--gold)]" data-testid="footer-newsletter-submit">
                {t.sections.newsletterBtn} →
              </button>
            </form>
            {status === "WELCOME10" && <p className="text-xs text-[var(--gold)] mt-3" data-testid="newsletter-success">Use code WELCOME10 — 10% off</p>}
          </div>

          <div>
            <h4 className="text-[11px] tracking-[0.25em] uppercase text-[var(--gold)] mb-5">{t.footer.shop}</h4>
            <ul className="space-y-3 text-sm text-[var(--grey-soft)]">
              <li><Link to="/shop" className="link-lux">{fl.shopAll}</Link></li>
              <li><Link to="/best-sellers" className="link-lux">{fl.bestSellers}</Link></li>
              <li><Link to="/shop" className="link-lux">{fl.bracelets}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[11px] tracking-[0.25em] uppercase text-[var(--gold)] mb-5">{t.footer.help}</h4>
            <ul className="space-y-3 text-sm text-[var(--grey-soft)]">
              <li><Link to="/contact" className="link-lux">{fl.contact}</Link></li>
              <li><Link to="/faq" className="link-lux">{fl.faq}</Link></li>
              <li><Link to="/shipping-policy" className="link-lux">{fl.shipping}</Link></li>
              <li><Link to="/refund-policy" className="link-lux">{fl.refund}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[11px] tracking-[0.25em] uppercase text-[var(--gold)] mb-5">{t.footer.company}</h4>
            <ul className="space-y-3 text-sm text-[var(--grey-soft)]">
              <li><Link to="/about" className="link-lux">{fl.about}</Link></li>
              <li><Link to="/jewelry-info" className="link-lux">{fl.jewelry}</Link></li>
              <li><Link to="/privacy-policy" className="link-lux">{fl.privacy}</Link></li>
              <li><Link to="/terms-of-service" className="link-lux">{fl.terms}</Link></li>
              <li><Link to="/legal-notice" className="link-lux">{fl.legal}</Link></li>
            </ul>
          </div>
        </div>

        <div className="divider-gold mt-16 mb-8" />

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <p className="text-xs text-[var(--grey)]">{t.footer.copyright}</p>
          <div className="flex items-center gap-3 flex-wrap">
            {["Visa", "Mastercard", "Amex", "PayPal", "ApplePay", "GooglePay", "Klarna", "Maestro", "Bancontact", "EPS", "ShopPay", "UnionPay"].map((p) => (
              <span key={p} className="px-2.5 py-1 border border-[var(--grey)]/50 text-[10px] tracking-[0.1em] text-[var(--grey-soft)]" data-testid={`pay-${p}`}>
                {p}
              </span>
            ))}
          </div>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-[var(--gold)]">
            <Instagram className="w-5 h-5" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
